export default __webpack_public_path__ + "static/media/Home2.0a1bc74f.png";